import { ElementCallIntent } from './elementCallIntent.js';
export const MAX_CALL_NOTIFICATION_LIFETIME_MS = 120_000;
const VOICE_INTENTS = new Set([
    ElementCallIntent.StartCallVoice,
    ElementCallIntent.JoinExistingVoice,
    ElementCallIntent.StartCallDMVoice,
    ElementCallIntent.JoinExistingDMVoice,
]);
const KNOWN_INTENTS = new Set(Object.values(ElementCallIntent));
export const normalizeCallIntent = (intentKindRaw, intentRaw) => {
    if (intentKindRaw === 'audio' || intentKindRaw === 'video') {
        return intentKindRaw;
    }
    if (!intentRaw)
        return 'audio';
    const normalized = intentRaw.toLowerCase();
    if (VOICE_INTENTS.has(normalized) || normalized.includes('voice')) {
        return 'audio';
    }
    if (KNOWN_INTENTS.has(normalized) || normalized.includes('video')) {
        return 'video';
    }
    return 'audio';
};
export const toCallNotificationType = (value) => value === 'ring' || value === 'notification' ? value : undefined;
export const toCallNotificationTypeOrDefault = (value, defaultType = 'ring') => toCallNotificationType(value) ?? defaultType;
//# sourceMappingURL=callIntent.js.map